import { useEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollUp() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth", // Enables smooth scrolling
    });
  }, [pathname]);

  return null; // This component does not render anything
}

export default ScrollUp;
